import React from 'react';
import PropTypes from 'prop-types';
import { skipToken } from '@reduxjs/toolkit/query';
import { Box, TextField } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useGetReportQuery } from '../../../../../../../../entities/reports/reportsResource/redux/reportsResource.api';
import Error from '../../../../../../../../shared/ui/Error/Error';
import { fileType } from '../../../../constants';
import renderControl from '../../../../utils/renderControl';
import SingleSelect from '../../../../../../../../shared/ui/SingleSelect';
import Container from './styles/Container';
import Wrapper from './styles/Wrapper';

function MainSection({ companyId, controls, setControls, selectedType, setSelectedType, reportName, setReportName }) {
  const [searchParams] = useSearchParams();

  const reportId = parseInt(searchParams.get('report'), 10);
  const report = useGetReportQuery(reportId ? { id: reportId } : skipToken);

  const handleChangeType = (event) => {
    setSelectedType(event.target.value);
  };

  const handleChangeValueControl = (id, value, helpData) => {
    setControls((prev) => {
      const newControls = [...prev];
      const index = newControls.findIndex((control) => control.id === id);
      newControls[index] = {
        ...newControls[index],
        value,
      };
      if (helpData) newControls[index].helpData = helpData;

      return newControls;
    });
  };

  const handleChangeText = (event) => {
    handleChangeValueControl(event.target.id, event.target.value);
  };

  const handleChangeDate = (date, name) => {
    handleChangeValueControl(name, date);
  };

  const handleChangeAutocomplete = (id, value) => {
    handleChangeValueControl(id, value);
  };

  const handleChangeRange = (id, value, helpData) => {
    handleChangeValueControl(id, value, helpData);
  };

  return (
    <Container>
      <TextField
        label="Название"
        value={reportName}
        onChange={(e) => setReportName(e.target.value)}
        variant="outlined"
        size="small"
        style={{ width: '400px' }}
      />
      {controls?.map((control) => (
        <Box key={control.id}>
          {renderControl(
            control,
            { companyId, isSchedule: true },
            {
              handleChangeText,
              handleChangeDate,
              handleChangeAutocomplete,
              handleChangeRange,
            },
          )}
        </Box>
      ))}
      {!!reportId && !report?.data?.reportParams?.length && <Error errorMessage="Пустой шаблон" />}
      <Wrapper>
        <SingleSelect
          value={selectedType}
          items={fileType}
          onChange={handleChangeType}
          label="Тип документа"
          name="fileType-label"
        />
      </Wrapper>
    </Container>
  );
}

MainSection.propTypes = {
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  controls: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  setControls: PropTypes.func.isRequired,
  selectedType: PropTypes.string.isRequired,
  setSelectedType: PropTypes.func.isRequired,
  reportName: PropTypes.string.isRequired,
  setReportName: PropTypes.func.isRequired,
};

export default MainSection;
